import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { PlayerModel } from "@/model/playerModel";
import router from "@/router";
import IMUtils from "@/network/socket/imUtils";
import { encryptionShowFocusHost, encryptionFocusHost } from "@/api/php/user"; 
import { storeToRefs } from "pinia"; 
import { Toast } from "vant";
import { YMPush } from "@/uitls/uitls";
import { usePiniaState } from "@/store/userPinia"; 
import { nativeToLogin, toMsgChat } from "@/uitls/native";
import { useI18n } from 'vue-i18n'
interface AnchorProps {
  roomdata: PlayerModel;
}

export default /*#__PURE__*/_defineComponent({
  name: 'Anchor',
  props: {
    roomdata: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
  roomdata: PlayerModel;
}

const { t } = useI18n() 
const userStore = usePiniaState();
const { isYk } = storeToRefs(userStore);
const isStart = ref(false);
const roomZb = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)
onMounted(() => {
  setTimeout(() => {
    getStart()
  }, 2000)
})




const getStart = async () => {
  if (isYk.value) {
    // 游客不需要查询
    return; 
  }

  const res: any = await encryptionShowFocusHost()
  if (res.code == 200 && res.data && res.data.length > 0) {
    const startList = res.data;
    for (let i = 0; i < startList.length; i++) {
      const element = startList[i];


      if (element.user_id == props.roomdata.user_id) {
        isStart.value = true;
      }
    }
  } else {
    console.log("没登录，获取关注列表失败");

  }
  // if (!isStart.value) {
  //   const data = {
  //     t: props.roomdata.live_trailer,
  //     a: props.roomdata.portrait,
  //     s: isStart.value,
  //     n: props.roomdata.nickname,
  //     id: props.roomdata.user_id
  //   }
  //   EventBus.emit("roomAleatUser", data);
  // }
}
const toStart = async () => {
  if (isYk.value) {
    return nativeToLogin(router);
  }
  window.$apiNet.statisticsPost({ action_id: '9', anchor_id: String(props.roomdata.user_id), room_key: String(props.roomdata.room_id) });// 统计打点
  //关注这个主播
  const res: any = await encryptionFocusHost({
    host_id: JSON.stringify([props.roomdata.user_id]),
  })
  if (res.code == 200) {
    Toast.success(t('me.gzcg'))
    isStart.value = true;
  } else {
    Toast.fail(res.msg)
  }
}
const enStart = async () => {
  //取消关注这个主播
  const res: any = await encryptionFocusHost({
    host_id: props.roomdata.user_id,
    del: 1
  })
  if (res.code == 200) {
    Toast.success(t('me.quxiaocg'))
    isStart.value = false;
  }
}
const toChat = (data) => {
  let chatkey;
  YMPush('CHAT', '私信主播');
  chatkey = IMUtils.createChatKey(data.free_id).toString()
  toMsgChat(router, data.free_id, chatkey)
}
// const primaryColor = process.env.VUE_APP_PRIMARY_COLOR as string;
const primaryColor = '#0D0D0D';

const filterHtml = (text) => {

  let info = "<p>" + text + "</p>";
  info = info.replace(/\n/g, '<br>')
  return info;
}


const __returned__ = { t, userStore, isYk, isStart, roomZb, props, getStart, toStart, enStart, toChat, primaryColor, filterHtml }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})